// extracted by mini-css-extract-plugin
module.exports = {"reports":"ReportContainer_reports__3l444"};